module.exports = __webpack_public_path__ + "img/violet_091.6f60c5bc.png";